export default "__VITE_ASSET__CoKmrQn1__"